export default __webpack_public_path__ + "static/media/place.1803e9ed.svg";